import React from 'react';
import { string } from 'prop-types';

const IconInfo = ({ fill = '#30435D' }) => {
  return (
    <svg
      data-test="iconInfo"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 0C4.032 0 0 4.032 0 9C0 13.968 4.032 18 9 18C13.968 18 18 13.968 18 9C18 4.032 13.968 0 9 0ZM9.90157 4.5H8.10156V6.3H9.90157V4.5ZM9.90157 8.10059H8.10156V13.5006H9.90157V8.10059ZM1.80078 8.99883C1.80078 12.9678 5.03178 16.1988 9.00078 16.1988C12.9698 16.1988 16.2008 12.9678 16.2008 8.99883C16.2008 5.02983 12.9698 1.79883 9.00078 1.79883C5.03178 1.79883 1.80078 5.02983 1.80078 8.99883Z"
        fill={fill}
      />
    </svg>
  );
};

IconInfo.propTypes = {
  fill: string,
};

export default IconInfo;
